import { useEffect, useState } from "react"
import { Container, Logo, Wrapper } from "./EventBar.styles"
//import LogoSilmo from "../../images/Logo-Silmo-Yellow.webp"
import LogoMido from "../../images/Logo-Mido-Booth.webp"
import {
   smallScreenPortraitValue,
   smallScreenValue,
   medScreenValue,
} from "../../Responsive"

const EventBar = () => {
   const [positionY, setPositionY] = useState(0)

   useEffect(() => {
      const screenWidth = window.innerWidth
      if (screenWidth > medScreenValue) {
         setPositionY(60)
      } else if (screenWidth > smallScreenValue) {
         setPositionY(80)
      } else if (screenWidth > smallScreenPortraitValue) {
         setPositionY(60)
      } else {
         setPositionY(40)
      }
   }, [])

   return (
      <Container>
         <Wrapper positionY={positionY}>
            <Logo src={LogoMido} />
         </Wrapper>
      </Container>
   )
}

export default EventBar
